import { Button } from "native-base";

export default Button;